var _rect, _path, _rect2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 25,
    viewBox: "0 0 37 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.866769,
    y: 0.465279,
    width: 35.0197,
    height: 24.1247,
    rx: 4.28018,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6324 16.5317H9.49512L7.89246 10.2376C7.81639 9.94812 7.65488 9.69216 7.41729 9.57152C6.82437 9.26836 6.17101 9.02709 5.45825 8.9054V8.66308H8.90116C9.37633 8.66308 9.73271 9.02709 9.79211 9.44984L10.6237 13.99L12.7598 8.66308H14.8377L11.6324 16.5317ZM16.0256 16.5317H14.0072L15.6692 8.66308H17.6877L16.0256 16.5317ZM20.299 10.8428C20.3584 10.419 20.7148 10.1766 21.1306 10.1766C21.7839 10.1158 22.4957 10.2375 23.0896 10.5396L23.446 8.84545C22.852 8.60313 22.1987 8.48145 21.6057 8.48145C19.6467 8.48145 18.2212 9.57137 18.2212 11.084C18.2212 12.2348 19.2309 12.839 19.9437 13.203C20.7148 13.566 21.0118 13.8083 20.9524 14.1713C20.9524 14.7157 20.3584 14.958 19.7655 14.958C19.0527 14.958 18.34 14.7766 17.6877 14.4734L17.3313 16.1686C18.044 16.4707 18.8152 16.5924 19.5279 16.5924C21.7245 16.6522 23.0896 15.5633 23.0896 13.929C23.0896 11.8708 20.299 11.7502 20.299 10.8428ZM30.1536 16.5317L28.551 8.66308H26.8295C26.4731 8.66308 26.1167 8.9054 25.9979 9.26836L23.0302 16.5317H25.108L25.5228 15.382H28.0758L28.3134 16.5317H30.1536ZM27.1265 10.7819L27.7194 13.7475H26.0573L27.1265 10.7819Z",
    fill: "#172B85"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.866769,
    y: 0.465279,
    width: 35.0197,
    height: 24.1247,
    rx: 4.28018,
    stroke: "#F2F4F7",
    strokeWidth: 0.778215
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.eb115e7a328451097c204a4b4ae3852b.svg";
export { ForwardRef as ReactComponent };